<template>
    <b-row>
        <b-col md="12">
            <b-card>
                <b-form v-on:submit.prevent enctype="multipart/form-data">
                    <b-row>
                        <b-col cols="3">
                            <b-form-group
                            label="Target Date"
                            label-for="target_date"
                            >
                                <flat-pickr
                                id="target_date"
                                v-model="form.target_date"
                                class="form-control"
                                :config="{ dateFormat: 'd-m-Y'}"
                                placeholder="Target Date"
                                />
                                <!-- <p>Value: '{{ form.target_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-form-group
                            label="Employees"
                            label-for="employees"
                            >
                                <v-select
                                id="employees"
                                v-model="form.selectedEmployees"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="form.optionsEmployees"
                                placeholder="Select 1 Employee"
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ form2.selectedEmployees }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                            label="Title"
                            label-for="title"
                            >
                            <b-form-input
                                id="title"
                                placeholder="Title"
                                v-model="form.title"
                                class="form-control"
                                required
                            />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                            label="Priority"
                            label-for="priotiry"
                            >
                                <v-select
                                id="priotiry"
                                v-model="form.selectedPriority"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="text"
                                :options="form.optionsPriority"
                                placeholder="Select Priority"
                                >
                                    <template #search="{attributes, events}">
                                        <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        />
                                    </template>
                                </v-select>
                                <!-- Selected: <strong>{{ form2.selectedPriority }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group
                            label="Description"
                            label-for="description"
                            >
                            <b-form-textarea
                                id="description"
                                placeholder="Description"
                                v-model="form.description"
                                class="form-control"
                                required
                            />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6">
                            <b-form-group
                            :state="errors"
                            label="Attachment"
                            label-for="Attachment"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display1" alt="display1" width="200" height="200" class="mb-1" :hidden="form.file1 ? false : true"> -->
                                <b-form-file
                                v-model="form.file1"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display1').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file1 ? form.file1.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="6" v-if="numberAttachment >= 1 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 2"
                            label-for="Attachment_2"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display2" alt="display2" width="200" height="200" class="mb-1" :hidden="form.file2 ? false : true"> -->
                                <b-form-file
                                v-model="form.file2"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display2').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file2 ? form.file2.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="6" v-if="numberAttachment >= 2 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 3"
                            label-for="Attachment_3"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display3" alt="display3" width="200" height="200" class="mb-1" :hidden="form.file3 ? false : true"> -->
                                <b-form-file
                                v-model="form.file3"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display3').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file3 ? form.file3.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="6" v-if="numberAttachment >= 3 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 4"
                            label-for="Attachment_4"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display4" alt="display4" width="200" height="200" class="mb-1" :hidden="form.file4 ? false : true"> -->
                                <b-form-file
                                v-model="form.file4"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display4').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file4 ? form.file4.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="6" v-if="numberAttachment >= 4 ">
                            <b-form-group
                            :state="errors"
                            label="Attachment 5"
                            label-for="Attachment_5"
                            invalid-feedback="Attachment is required"
                            >
                                <!-- <img id="display5" alt="display5" width="200" height="200" class="mb-1" :hidden="form.file5 ? false : true"> -->
                                <b-form-file
                                v-model="form.file5"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                accept="image/*, application/pdf"
                                onchange="document.getElementById('display5').src = window.URL.createObjectURL(this.files[0])"
                                />
                                <!-- Selected file: <strong>{{ form.file5 ? form.file5.name : '' }}</strong> -->
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="numberAttachment < 4" class="mb-1">
                        <b-col md="12" class="mt-1">
                            <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="secondary"
                            class="mr-1"
                            block
                            @click="moreAttachment()"
                            >
                            Add More Attachment
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-button
            class="mt-0"
            type="submit"
            variant="primary"
            block
            @click="addTarget()"
            >
                Submit Target
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
import {
    BFormTextarea, BDropdownItem, BDropdown, BBadge, BPagination, BFormFile, BImg, BFormSelect, BListGroupItem, BAvatar, BCard, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ImageUploader from 'vue-image-upload-resize'
import { $themeConfig } from "@themeConfig"
import Cleave from 'vue-cleave-component'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        flatPickr,
        VueGoodTable,
        ToastificationContent,
        vSelect,
        ImageUploader,
        Cleave,
        BFormTextarea,
        BPagination,
        BBadge,
        BDropdownItem,
        BDropdown,
        ValidationProvider,
        ValidationObserver,
        BFormFile,
        BImg,
        BFormSelect,
        BListGroupItem,
        BAvatar,
        BCard,
        BCardText,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BForm,
        BButton,
        Prism
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            form: {
                target_date: null,
                selectedEmployees: null,
                optionsEmployees: [],
                workers: [],
                title: '',
                selectedPriority: null,
                optionsPriority: [
                    {value: 1, text: 'Low'},
                    {value: 2, text: 'Normal'},
                    {value: 3, text: 'High'},
                    {value: 4, text: 'Urgent'}
                ],
                description: '',
                file1: null,
                file2: null,
                file3: null,
                file4: null,
                file5: null
            },
            numberAttachment: 0,
            hasImage: '',
            image: '',
            photo: '',
            pageLength: 10,
            dir: false,
            columns: [
                {
                label: 'Image',
                field: 'image',
                },
                {
                label: 'Code',
                field: 'code',
                },
                {
                label: 'Name',
                field: 'name',
                },
                {
                label: 'Qty',
                field: 'qty',
                },
                {
                label: 'Unit',
                field: 'unit_name',
                },
                {
                label: 'Price',
                field: 'price',
                },
                {
                label: 'Action',
                field: 'action',
                },
            ],
            rows: [],
            searchTerm: '',
            errors: '',
            errMessage: ''
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                1 : 'light-success',
                0 : 'light-danger'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    setup() {
        // App Name
        const { baseUrl, apiUrl } = $themeConfig.app;
        return {
            baseUrl,
            apiUrl
        };
    },
    created() {
        this.getEmployees()
    },
    methods: {
        getEmployees() {
            this.$http.get('employees')
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.form.optionsEmployees.push($data)
                }
                // console.log(this.form.optionsEmployees)
            });
        },
        moreAttachment() {
            this.numberAttachment += 1
        },
        addTarget() {
            if(this.form.target_date === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Target Date Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.selectedEmployees === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Employees Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.title === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Title Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.selectedPriority === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Priority Field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.form.description === '') {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Description Field is required',
                        variant: 'warning',
                    },
                })
            } else {
                let formData = new FormData();
                formData.append("target_date", this.form.target_date)
                formData.append("worker", this.form.selectedEmployees.value)
                formData.append("title", this.form.title)
                formData.append("description", this.form.description)
                formData.append("priority", this.form.selectedPriority.value)
                if(this.form.file1 !== null) {
                    formData.append("attachment_1", this.form.file1)
                }
                if(this.form.file2 !== null) {
                    formData.append("attachment_2", this.form.file2)
                }
                if(this.form.file3 !== null) {
                    formData.append("attachment_3", this.form.file3)
                }
                if(this.form.file4 !== null) {
                    formData.append("attachment_4", this.form.file4)
                }
                if(this.form.file5 !== null) {
                    formData.append("attachment_5", this.form.file5)
                }
                this.$http
                .post("sales/target/add", formData)
                .then((response) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: 'Success add Target',
                            variant: 'success',
                        },
                    })
                    location.href = "/sales/target"
                }).catch((errors) => {
                    this.errMessage = errors.response.data.message
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: this.errMessage,
                            variant: 'warning',
                        },
                    })
                    console.log(errors.response)
                });
            }
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import "@core/scss/vue/libs/vue-good-table.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>